import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { OutOfStockOrder } from '../types/OutOfStockOrder';

export const useGetOutOfStockOrders = (productID: number | undefined) => {
    const { data, isLoading, error } = useQuery<OutOfStockOrder[]>({
        enabled: !!productID,
        queryKey: ['out-of-stock-orders', productID],
        queryFn: async () => {
            const response = await apiClient.get('purchase-order/out-of-stock-orders', {
                params: { productID },
            });
            
            return Array.isArray(response) ? response : [];
        },
    });

    return {
        data: data || [], 
        isLoading,
        error,
    };
};
